export default "<div\r\n\tclass=\"json-schema-markdown\"\r\n\tng-if=\"$ctrl.html\"\r\n\tng-bind-html=\"$ctrl.html\">\r\n</div>\r\n";